import { http, HttpResponse } from 'msw';
import { v4 as uuid } from 'uuid';

import { SubmitApplicationResponse } from '../../api/submitApplication';
import { MockServiceWorker } from '../mockServiceWorker';

export const submitHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/submit/RESURS', async () => {
        const response: SubmitApplicationResponse = {
            applicationReferenceNumber: uuid(),
        };

        const session = MockServiceWorker.getMockedSession();
        MockServiceWorker.setMockedSession({ ...session, state: 'ACCEPT_OFFER_MAIN_APPLICANT' });

        return HttpResponse.json(response);
    }),
];
